module.exports = __webpack_public_path__ + "static/media/dst_group.216f54b3.webp";